import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Angular Tutor';
}



// WEBPACK FOOTER //
// /builds/angulartutor/angulartutor.gitlab.io/src/app/app.component.ts